import React from 'react'
import { Button } from 'src/Common/ui/button'

function ApplyCancel ({ handleCancel, handleSave, loading, buttonName, disable }) {
    return (
        <>
            <div className="w-full flex justify-end space-x-4 p-2">
                <Button
                    variant='outline'
                    style={{ color: 'hsl(var(--destructive))', background: 'white', borderColor: 'hsl(var(--destructive))' }}
                    onClick={handleCancel}
                    disabled={loading}
                >
                            Cancel
                </Button>
                <Button onClick={handleSave} disabled={loading || disable}>
                    {buttonName}
                </Button>
            </div>
        </>
    )
}

export default ApplyCancel
